<div class="add-core-result">
  <ng-container #container></ng-container>
</div>
